import { string, number, shape, func, arrayOf, instanceOf, bool, object } from 'prop-types';

const routePropTypes = shape({
  id: number,
  description: string,
  lineDisplayProperty: shape({
    color: string
  }),
  lineGeoStats: shape({
    distanceTotal: string,
    elevationEnd: number,
    elevationGain: number,
    elevationLoss: number,
    elevationMax: number,
    elevationMin: number,
    elevationStart: number
  }),
  lineSegments: arrayOf(
    shape({
      dateTimeStart: instanceOf(Date),
      dateTime: instanceOf(Date),
      id: number,
      polyline: shape({
        elevationData: string,
        indexedElevationData: string,
        pointsData: string
      }),
      sequence_num: number
    })
  ),
  location: shape({
    city: string,
    country: string,
    country_id: number,
    latitude: string,
    longitude: string,
    postalCode: string,
    region: string
  }),
  name: string,
  rating: number,
  sequence_num: number,
  status: string,
  trailId: number
});

const providedPropTypes = shape({
  dragHandleProps: shape({
    'aria-describedby': string,
    'data-rdb-drag-handle-context-id': string,
    'data-rdb-drag-handle-draggable-id': string,
    draggable: bool,
    onDragStart: func,
    role: string,
    tabIndex: number
  }),
  draggableProps: shape({
    'data-rdb-draggable-context-id': string,
    'data-rdb-draggable-id': string,
    onTransitionEnd: func,
    style: shape({
      transform: string,
      transition: string
    }),
    innerRef: func
  })
});

const descriptionFormPropTypes = {
  title: string,
  description: string,
  activity: object,
  private: bool,
  date: instanceOf(Date)
};

const waypointPropTypes = shape({
  at_map_id: number,
  description: string,
  name: string,
  id: number,
  location: shape({
    latitude: number,
    longitude: number
  }),
  order: number,
  waypointDisplayProperty: shape({
    showTitle: bool
  })
});

const trailPropTypes = shape({
  ID: number,
  activities: arrayOf(string),
  area_id: number,
  area_name: string,
  area_name_de: string,
  area_name_en: string,
  area_name_es: string,
  area_name_fr: string,
  area_slug: string,
  avg_rating: number,
  city_id: number,
  city_name: string,
  country_id: number,
  country_name: string,
  description: string,
  description_de: string,
  description_en: string,
  description_es: string,
  description_fr: string,
  difficulty_rating: string,
  duration_minutes: number,
  elevation_gain: number,
  features: arrayOf(string),
  length: number,
  name: string,
  name_de: string,
  name_en: string,
  name_es: string,
  name_fr: string,
  num_photos: number,
  num_reviews: number,
  objectID: string,
  overview: string,
  park_slug: string,
  popularity: number,
  profile_photo_url: string,
  route_type: string,
  slug: string,
  state_id: number,
  state_name: string,
  trail_id: number,
  type: string,
  units: string,
  verified_map_id: number,
  visitor_usage: string,
  _geoloc: shape({ lat: number, lng: number })
});

const trailContextPropTypes = shape({
  adminOrPendingOwner: bool,
  adminUser: bool,
  currentUser: object,
  displayMetric: bool,
  languageRegionCode: string,
  loggedInUser: bool,
  mobileBrowser: bool,
  proUser: bool,
  shortLocale: string,
  tabletBrowser: bool
});

const contextPropTypes = shape({
  currentUser: object,
  adminUser: bool,
  proUser: bool,
  mobileBrowser: bool,
  tabletBrowser: bool,
  displayMetric: bool,
  languageRegionCode: string,
  forceProLogo: bool,
  featureFlags: shape({
    communityFeatureFlag: bool
  })
});

export { routePropTypes, providedPropTypes, descriptionFormPropTypes, waypointPropTypes, trailPropTypes, trailContextPropTypes, contextPropTypes };
